import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { site } from "../data/site";
import { getArticle } from "../data/articles";

// Markdown mínimo y seguro (sin HTML): ## h2, ### h3, listas "- ", **negrita**.
const renderInline = (text) =>
  text.split(/(\*\*.+?\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") && part.length > 4
      ? <strong key={i}>{part.slice(2, -2)}</strong>
      : part
  );

const renderMarkdown = (md) => {
  const blocks = md.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return blocks.map((b, i) => {
    if (b.startsWith("### ")) return <h3 key={i}>{b.slice(4)}</h3>;
    if (b.startsWith("## ")) return <h2 key={i}>{b.slice(3)}</h2>;
    if (b.startsWith("- ")) {
      return (
        <ul key={i}>
          {b.split("\n").map((li, j) => <li key={j}>{renderInline(li.replace(/^-\s*/, ""))}</li>)}
        </ul>
      );
    }
    return <p key={i}>{renderInline(b)}</p>;
  });
};

export const BlogPost = () => {
  const { slug } = useParams();
  const article = getArticle(slug);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [slug]);

  if (!article) return (
    <div className="post"><div className="container">
      <Seo title="Artículo no encontrado | Yasmina" description="Este artículo no existe." path={`/blog/${slug}`} noindex />
      <h1>Artículo no encontrado</h1>
      <p>Vuelve al <Link to="/blog" style={{ color: "var(--gold)" }}>blog</Link>.</p>
    </div></div>
  );

  return (
    <article className="post" data-testid="blog-post">
      <Seo title={`${article.title} | Yasmina Puigcerdà`} description={article.excerpt} path={`/blog/${article.slug}`} image={article.cover} />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org", "@type": "BlogPosting",
        headline: article.title, description: article.excerpt, image: article.cover,
        datePublished: article.date, inLanguage: "es",
        author: { "@type": "Organization", name: "Yasmina" },
        publisher: { "@type": "Organization", name: "Yasmina" },
      })}</script>
      <div className="container">
        <Link to="/blog" className="meta" style={{ display: "inline-block", marginBottom: 20 }}>← Volver al blog</Link>
        <Reveal>
          <div className="meta">
            {new Date(article.date).toLocaleDateString("es-ES", { day: "2-digit", month: "long", year: "numeric" })}
            {" · "}{article.readingTime}
          </div>
        </Reveal>
        <Reveal delay={1}>
          <h1>{article.title}</h1>
        </Reveal>
        <Reveal delay={2}>
          <div className="cover" style={{ backgroundImage: `url(${article.cover})` }} role="img" aria-label={article.title} />
        </Reveal>
        <Reveal delay={2}>
          <div>{renderMarkdown(article.content)}</div>
        </Reveal>
        <div style={{ marginTop: 50, padding: "30px", background: "var(--card)", border: "1px solid var(--border)", borderLeft: "3px solid var(--gold)", textAlign: "center" }}>
          <h3 style={{ marginBottom: 12 }}>¿Quieres probarlo?</h3>
          <p style={{ marginBottom: 20 }}>Reserva tu mesa en Yasmina, Plaça del Reg de Puigcerdà.</p>
          <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn primary" data-testid="post-cta-wa">Cómo llegar</a>
        </div>
      </div>
    </article>
  );
};
